import React, { useEffect, useState, useRef } from 'react'
import {
  Button,
  Col,
  Icon,
  Input,
  message,
  Modal,
  Row,
  Select,
  Table,
  Tag,
  Tooltip,
  Typography
} from 'antd';
import AstRecord from './AstRecord';
import PhotoGalleryModal from './PhotoGalleryModal';
import PhotoThumb from './PhotoThumb';
import './style.css'
import { Link } from 'react-router-dom';

function AstReconciliation({ data: astData, voucher, locations, clients, setExportedData, exportedData, ...props }) {
  const [columns, setColumns] = useState([])

  const [searchText, setsearchText] = useState('');
  const [searchedColumn, setsearchedColumn] = useState();
  const searchInput = useRef(null);

  const [astDataSummeryStatus, setAstSummeryStatus] = useState(null)
  const [data, setData] = useState([])
  const [actions, setActions] = useState([])

  useEffect(() => {
    const options = props.filters && props.filters['actionTaken.name'] && props.filters['actionTaken.name']['options'] && props.filters['actionTaken.name']['options']['enum']
    setActions(options || []);
  }, [props.filters])

  useEffect(() => {
    // console.log(astData);

    setData(astData)
  }, [astData]);


  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            searchInput.current = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.current.select(), 100);
      }
    },
    render: (text) => (dataIndex !== 'location' && dataIndex !== 'client') ?
      (text)
      :
      dataIndex === 'location' ? (text && props.authUser && props.authUser.locations && props.authUser.locations.length)
        && props.authUser.locations.findIndex(loc => loc._id === text) >= 0 && props.authUser.locations[props.authUser.locations.findIndex(loc => loc._id === text)]['name']
        :
        dataIndex === 'client' ? (text && props.authUser && props.authUser.clients && props.authUser.clients.length)
          && props.authUser.clients.findIndex(loc => loc._id === text) >= 0 && props.authUser.clients[props.authUser.clients.findIndex(loc => loc._id === text)]['name'] : ''
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setsearchText(selectedKeys[0]);
    setsearchedColumn(dataIndex);
  };

  const handleReset = clearFilters => {
    clearFilters();
    setsearchText('');
  };

  useEffect(() => {
    // const options = props.filters && props.filters['actionTaken.name'] && props.filters['actionTaken.name']['options'] && props.filters['actionTaken.name']['options']['enum']
    // console.log(options)
    setColumns(
      [
        // {
        //   title: '_id',
        //   dataIndex: '_id',
        //   key: '_id',
        // },
        {
          title: 'Asset',
          dataIndex: 'assetCode',
          key: 'assetCode',
          ...getColumnSearchProps('assetCode'),
        },
        {
          title: 'AST',
          dataIndex: 'astNo',
          key: 'astNo',
          // ...getColumnSearchProps('astNo'),
          render: (astNo, record) => {
            return <Button type='link' onClick={() => handleShowModel(record._id)}>{astNo}</Button>

          }
        },
        {
          title: 'Photos',
          key: 'photos',
          // Thumbnail of the first inline photo + exact count badge. Uses record.photos
          // directly (no fetch). Click opens the full gallery.
          render: (_, record) => (
            <PhotoThumb photos={record && record.photos} onClick={() => handleShowGallery(record)} />
          )
        },
        {
          title: 'Location',
          dataIndex: 'location',
          key: 'location',
          filters: locations && locations.map(l => ({ text: l.name, value: l._id })),
          onFilter: (value, record) => record.location.indexOf(value) === 0,
          render: location => {
            if (location && locations.length) {
              const locIndex = locations.findIndex(loc => loc._id === location);
              return locIndex >= 0 && locations[locIndex]['name']
            }
          },
          // ...getColumnSearchProps('location'),
        },
        {
          title: 'SubLocation',
          dataIndex: 'client',
          key: 'client',
          render: client => {
            if (client && clients.length) {
              const clIndex = clients.findIndex(cl => cl._id === client);
              return clIndex >= 0 && clients[clIndex]['name']
            }
          },
          filters: (props.authUser && clients && clients.map(c => ({ text: c.name, value: c._id }))),
          onFilter: (value, record) => record.client.indexOf(value) === 0,
        },
        {
          title: 'Status',
          dataIndex: 'reconcileStatus',
          key: 'reconcileStatus',
        },
        {
          title: 'Is Saved',
          dataIndex: 'isAlreadySaved',
          key: 'isAlreadySaved',
          render: (isAlreadySaved) => isAlreadySaved ? <Tooltip title="Yes"><Icon type="check-circle" style={{ fontSize: '25px' }} theme="twoTone" twoToneColor="#52c41a" /></Tooltip> :
            <Tooltip title="No"><Icon type="close-circle" theme="twoTone" style={{ fontSize: '25px' }} twoToneColor="#eb2f96" /></Tooltip>
        },
        {
          title: 'Action',
          key: 'action',
          render: (_, record) => {
            // console.log(record && record.actionTaken && record.actionTaken.name);
            let value = record && record.actionTaken && record.actionTaken.name;
            if (!value) {
              // value = record.reconcileStatus && record.reconcileStatus === 'SOLD' ? 'IGNORE' : ''
            }
            // console.log(value);

            // ||(record.reconcileStatus && record.reconcileStatus === 'FULLY_MATCHED') ? 'RECONCILED' : record.reconcileStatus === 'SOLD' ? 'SOLD' : ''
            return (
              <Select
                allowClear
                disabled={record && record.isProcessed}
                value={value}
                style={{ width: 120 }}
                onChange={value => handleFirstSelectChange(value, record)}
              >
                {['RECONCILED', 'NEW_ASSET', 'ATA_ARN', 'SOLD', 'IGNORE'].map(op => <Select.Option key={op} value={op}><Tooltip title={op}>{op}</Tooltip></Select.Option>)}
              </Select>
            )
          }
        },
        {
          title: 'Is Processed',
          dataIndex: 'isProcessed',
          key: 'isProcessed',
          render: (isProcessed) => isProcessed ? <Tooltip title="Yes"><Icon type="check-circle" style={{ fontSize: '25px' }} theme="twoTone" twoToneColor="#52c41a" /></Tooltip> :
            <Tooltip title="No"><Icon type="close-circle" theme="twoTone" style={{ fontSize: '25px' }} twoToneColor="#eb2f96" /></Tooltip>
        },
        {
          title: 'Remarks',
          dataIndex: 'processedRemark',
          key: 'processedRemark',
        },
        {
          title: 'Asset Data',
          dataIndex: 'matchedAsset',
          key: 'matchedAsset',
          render: matchedAsset => {
            if (!matchedAsset) return null;
            return (
              <>
                <Link target="_blank" to={`/asset/history-report/${matchedAsset._id}`}>
                  {matchedAsset.assetCode}
                </Link>
                {' '}
                ({matchedAsset.altName})
                {' '}
                | {matchedAsset.ownerCode}
              </>
            );

          },
        },
        {
          title: 'Asset Location',
          dataIndex: 'matchedAsset',
          key: 'matchedAssetLocation',
          render: matchedAsset => {
            if (matchedAsset && matchedAsset.location && locations.length) {
              const locIndex = locations.findIndex(loc => loc._id === matchedAsset.location);
              return locIndex >= 0 && locations[locIndex]['name']
            }
          },
        },
        {
          title: 'Asset Sub Location',
          dataIndex: 'matchedAsset',
          key: 'matchedAssetClient',
          render: matchedAsset => {
            if (matchedAsset && matchedAsset.client && clients.length) {
              const clIndex = clients.findIndex(cl => cl._id === matchedAsset.client);
              return clIndex >= 0 && clients[clIndex]['name']
            }
          },
        },
      ]
    )
  }, [props.filters, data]);

  const rowClassName = (record) => {
    return record.isProcessed ? 'row-processed' : record.isAlreadySaved ? 'row-saved' : '';
  };

  const [bulkActionValue, setBulkActionValue] = useState(null);


  const handleFirstSelectChange = (value, record) => {
    // console.log(`${record.reconcileStatus} -> ${value}`)
    if (value) {
      Modal.confirm({
        title: `Are you sure to add ${value} to this record ?`,
        content: <div>Please Confirm!</div>,
        okText: 'OK',
        cancelText: 'Cancel',
        // width: '55%',
        // confirmLoading: true,
        onOk: () => {
          setData(data.map(doc => {
            if (doc._id === record._id)
              doc.actionTaken = { name: value, refRecordId: ['RECONCILED', 'ATA_ARN', 'SOLD'].includes(value) ? (record.matchedAsset && record.matchedAsset._id) : null }
            return doc
          }))
        },
      });
    } else {
      setData(data.map(doc => {
        if (doc._id === record._id)
          delete doc.actionTaken
        return doc
      }))
    }
  };

  const handleBulkActionChange = () => {
    // console.log(`${record.reconcileStatus} -> ${value}`)
    if (bulkActionValue) {
      Modal.confirm({
        title: `Are you sure to add ${bulkActionValue} for all records ?`,
        content: <div>Are you sure ?</div>,
        okText: 'Yes',
        cancelText: 'Cancel',
        // width: '55%',
        // confirmLoading: true,
        onOk: () => {
          setData(data.map(doc => {
            if (!doc.isAlreadySaved && !(doc.actionTaken && doc.actionTaken.name))
              doc.actionTaken = { name: bulkActionValue, refRecordId: ['RECONCILED', 'ATA_ARN', 'SOLD'].includes(bulkActionValue) ? (doc.matchedAsset && doc.matchedAsset._id) : null }
            return doc;
          }))
          // setData(data);
        },
      });
    }
  };

  const [showModel, setshowModel] = useState(false);
  const [showModelData, setshowModelData] = useState(null);

  const handleShowModel = (astAssetRecordId) => {
    if (astAssetRecordId) {
      const ast = data.filter(d => d._id === astAssetRecordId)
      // console.log(astAssetRecordId, ast);
      setshowModelData(ast && ast[0]);
      setshowModel(true);
    }
  }

  const hideModel = () => {
    setshowModel(false)
  }

  // ----- Photo gallery pop-up (per-row photos captured during AST) -----
  const [showGallery, setShowGallery] = useState(false);
  const [galleryData, setGalleryData] = useState(null);

  const handleShowGallery = (record) => {
    setGalleryData(record);
    setShowGallery(true);
  };

  const hideGallery = () => setShowGallery(false);

  useEffect(() => {
    const countReconciliationStatus = (arr) => {
      return arr.reduce((acc, curr) => {
        acc[curr.reconcileStatus] = (acc[curr.reconcileStatus] || 0) + 1;
        // Count the actionTaken.name (handle cases where actionTaken or name is missing)
        const actionName = `ACTION_${(curr.actionTaken && curr.actionTaken.name) || 'NO-ACTION'}`;
        // const actionName = curr.actionTaken?.name || 'NoAction';
        acc[actionName] = (acc[actionName] || 0) + 1;
        return acc;
      }, {});
    };
    // console.log(data)
    if (data && data.length)
      setAstSummeryStatus(countReconciliationStatus(data))
    else
      setAstSummeryStatus(null)

    const { allAssets, pvAssets, astAssets } = exportedData || {};
    setExportedData({ allAssets, pvAssets, astAssets: data })

  }, [data]);


  const submitReconcileData = () => {
    // console.log(data)
    const payload = data.filter(doc => doc.actionTaken && doc.actionTaken.name && !doc.isProcessed)
    // console.log(payload);
    if (payload && payload.length) {
      Modal.confirm({
        title: `Are you sure to save ${payload.length} records! ?`,
        content: <div>Are you sure ?</div>,
        onOk: () => {
          message.info(`${payload.length} records will be saving!`)
          props.saveReconciliationData(payload, voucher);
        },
      });
    }
  }

  const processReconcileData = () => {
    // console.log(data)
    const payload = data.filter(doc => doc.actionTaken && doc.actionTaken.name && doc.isAlreadySaved && !doc.isProcessed)
    // console.log(payload);
    Modal.confirm({
      title: `Are you sure to process ${payload.length} records! ?`,
      content: <div>Are you sure ?</div>,
      onOk: () => {
        message.info(`${payload.length} records will be process!`)
        props.processReconciliationData(payload, voucher);
      },
    });
  }

  const changeTable = (pagination, filters, sorter, extra) => {
    // console.log(pagination, filters);
    // console.log(extra);

    const { currentDataSource } = extra;
    setData(currentDataSource)

  }

  const checkEliglbleForSave = () => {
    //check add records have action added
    const saved = data.filter(doc => doc.actionTaken && doc.actionTaken.name)
    // console.log(saved);
    return saved.length

  }

  const checkEliglbleForProcess = () => {
    //check add records have action added and already saved
    return data.filter(doc => doc.actionTaken && doc.actionTaken.name && doc.isAlreadySaved).length
  }

  return (
    <div>
      <AstRecord onCancel={hideModel} visible={showModel} data={showModelData} locations={locations} clients={clients} />
      <PhotoGalleryModal
        visible={showGallery}
        onCancel={hideGallery}
        photos={galleryData && galleryData.photos}
        title={galleryData && (galleryData.assetCode || galleryData.astNo)}
      />
      {data && data.length > 0 && (
        <Row gutter={[16, 16]}>
          <Col key={'total'}>
            <Tag color='magenta'>{`Total: ${data.length}`}</Tag>
          </Col>
        </Row>
      )}

      {astDataSummeryStatus && <>
        <Row gutter={[16, 16]}>
          {Object.entries(astDataSummeryStatus)
            .filter(([status]) => !/^ACTION_/.test(status))
            .map(([status, count]) => (
              <Col key={status}>
                <Tag>{`${status}: ${count}`}</Tag>
              </Col>
            ))
          }
        </Row>
        <Row gutter={[16, 16]}>
          {Object.entries(astDataSummeryStatus)
            .filter(([status]) => /^ACTION_/.test(status))
            .map(([status, count]) => (
              <Col key={status}>
                <Tag className='gx-rounded-md' color='#06BB8A'>{`${status}: ${count}`}</Tag>
              </Col>
            ))
          }
        </Row>
      </>}
      {/* {astDataSummeryStatus && (
        <Row gutter={[16, 16]}>
          {Object.entries(astDataSummeryStatus).map(([status, count]) => (
            <Col key={status}>
              <Tag className={/^ACTION_/.test(status) ? 'gx-rounded-md' : ''} color={/^ACTION_/.test(status) ? '#06BB8A' : ''}>{`${status}: ${count}`}</Tag>
            </Col>
          ))}
        </Row>
      )} */}
      {data && <Table size='small' dataSource={data} columns={columns} rowKey={(record) => `${record.time}-${record._id}`} onChange={changeTable} rowClassName={rowClassName} />}
      <div style={{ marginTop: '10px' }}>
        <Row gutter={8}>
          <Col xs={24} sm={12} md={8} lg={4} xl={4}>
            <Select
              allowClear
              style={{ width: '100%' }}
              onChange={value => setBulkActionValue(value)}
            >
              {['RECONCILED', 'NEW_ASSET', 'ATA_ARN', 'SOLD', 'IGNORE'].map(op => <Select.Option key={op} value={op}><Tooltip title={op}>{op}</Tooltip></Select.Option>)}
            </Select>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4} xl={4}>
            <Button disabled={!data || !data.length} type='dashed' onClick={handleBulkActionChange} icon='left'> Add This Action to all above</Button>
          </Col>
        </Row>
      </div>

      <div style={{ float: 'right', marginTop: '10px' }}>
        <Button type="primary"
          htmlType="button" loading={props.loading} onClick={submitReconcileData}>
          Save
        </Button>
        <Button style={{ marginLeft: '5px' }} type="danger" htmlType="button" loading={props.loading}
          onClick={processReconcileData}>
          Process Report
        </Button>
      </div>

    </div>
  )

}

export default AstReconciliation;
